module.exports = __webpack_public_path__ + "static/media/FROMAS_S.5beccb71.png";